module.exports = __webpack_public_path__ + "static/media/googlePay.292ab00d.svg";